module.exports = __webpack_public_path__ + "img/7.02b91352.jpg";